import React, {Component} from 'react';

import styled from '@emotion/styled';

import {connect} from 'react-redux';
import {userActions} from '../_actions';

import GistLogo from "./GistLogo";
import sv from "../styles/marketing";
import {withRouter} from "react-router-dom";
import {FontAwesomeIcon} from "@fortawesome/react-fontawesome";
import {faLink, faPlus} from "@fortawesome/free-solid-svg-icons";
import {UserInfo} from "./UserInfo";
import {uiConstants} from "../_constants";
import {IconButton, Menu, MenuItem, withStyles} from "@material-ui/core";
import AccountCircle from "@material-ui/icons/AccountCircle";
import {withTranslation} from "react-i18next";
import {authenticationState} from "../_constants/commons/authenticationState";
import HTMLDocumentHeadCustomizer from "./HTMLDocumentHeadCustomizer";
import {isMobileOnly} from "react-device-detect";
import zoomIcon from "../images/zoom.svg"
import {FaRegFileVideo} from "react-icons/fa";
import {StretchedBackground} from "./commons/StretchedBackground";

// STYLE ##########################################################

const HeaderWrapper = styled('div')`
  margin-bottom: ${props => props.isMobile? sv.vEndSpacingXS + 'px' : sv.vEndSpacing + 'px'};
`;

const HeaderContent = styled(`div`)`
  width: 100%;
  ${sv.flexRow};
  align-items: center;
	padding: 15px 0;
  flex-wrap: wrap;
  justify-content: space-around;
	gap: 5px;
`;

const LogoContainer = styled(`div`)`
  min-width: 100px;
  z-index: 20;
`;

const Navigation = styled(`div`)`
  flex: 1;
  ${sv.flexRow};
  justify-content: flex-end;
  @media(max-width: 720px) {
    ${props => props.hideSmallScreens ? 'display: none;' : ''};
  }
  white-space: nowrap;
  z-index: 20;
`;

const TextNavigationGroup = styled('div')`
  padding-right: 16px;
  padding-left: 16px;
  display: flex;
  flex-direction: row;
  justify-content: flex-end;
  flex: 10;
`;

const OutlineButton = styled(`div`)`
  padding: 5px 16px;
  font-size: 15px;
  font-weight: 600;
  color: ${props => props.lightColor ? sv.colors.light : sv.colors.body};
  flex-basis: 32px;
  white-space: nowrap;
  cursor: pointer;
  @media(max-width: 650px) {
    ${props => props.hideSmallScreens ? 'display: none;' : ''};
  }
  @media(max-width: 420px) {
    padding: 5px 8px;
  }
`;

const PitchButton = styled(`div`)`
  ${sv.buttonBase};
  font-size: 15px;
  background: ${props => props.brightColor ? 'rgba(255,255,255,.75)' : sv.colors.cta};
  color: ${props => props.brightColor ? sv.colors.body : sv.colors.light};
  box-shadow: 0 2px 4px rgba(0,0,0,.05);
  border: ${props => props.brightColor ? ('2px ' + sv.colors.subtleGrey + ' solid') : ''};
  &:hover {
    box-shadow: 0 3px 6px rgba(0,0,0,.1);
  }
  @media(max-width: 420px) {
    padding: 5px 8px;
  }
`;

const OrderMenuLogoContainer = styled(`div`)`
    margin-left: 5px;
`;

const ZoomIconContainer = styled(`div`)`
  max-width: 70px;
  max-height: 20px;
  overflow: hidden;
  margin-top: 2px;
`;

const ZoomIcon = styled('img')`
  position: relative;
  width: 90px;
  top: -10px;
  left: -10px;
`;

const RolloverMenuItem = withStyles(theme => ({
    root: {
        '&:hover': {
            backgroundColor: theme.palette.primary.light,
        },
        "padding-left": "30px"
    }
}))(MenuItem);

// COMPONENT ##########################################################

const MENU_HOVER_DELAY = 750;

class Header extends Component {

    constructor(props) {
        super(props);

        this.state = {
            accountMenuAnchor: null,
            orderMenuAnchor: null,
        };

        this.handleLogout = this.handleLogout.bind(this);

        this.showOrderMenu = this.showOrderMenu.bind(this);
        this.handleMouseOverOrder = this.handleMouseOverOrder.bind(this);
        this.handleCloseOrderMenu = this.handleCloseOrderMenu.bind(this);

        this.showAccountMenu = this.showAccountMenu.bind(this);
        this.handleClickAccount = this.handleClickAccount.bind(this);
        this.handleMouseOverAccount = this.handleMouseOverAccount.bind(this);
        this.handleCloseAccountMenu = this.handleCloseAccountMenu.bind(this);
    }

    componentWillUnmount() {
        clearTimeout(this.accountMenuHover);
        clearTimeout(this.orderMenuHover);
    }

    handleLogout(e) {
        e.preventDefault();
        this.props.clearAuthState();
    }

    showOrderMenu(target) {
        this.setState({orderMenuAnchor: target});
    }

    handleMouseOverOrder(e) {
        const target = e.currentTarget;
        clearTimeout(this.orderMenuHover);
        this.orderMenuHover = setTimeout(() => this.showOrderMenu(target), MENU_HOVER_DELAY);
    }

    handleCloseOrderMenu() {
        this.setState({orderMenuAnchor: null});
    }

    showAccountMenu = (target) => {
        this.setState({accountMenuAnchor: target});
    };

    handleClickAccount(e) {
        this.showAccountMenu(e.currentTarget);
    }

    handleMouseOverAccount(e) {
        const target = e.currentTarget;
        clearTimeout(this.accountMenuHover);
        this.accountMenuHover = setTimeout(() => this.showAccountMenu(target), MENU_HOVER_DELAY);
    }

    handleCloseAccountMenu() {
        this.setState({accountMenuAnchor: null});
    }

    onClickGetStarted = () => {
        // redirect to signup
        this.props.history.push('/signup');
    };

    render() {
        const {authState, t, screen, pageTitle, hideOrderOrPortfolio, lightColor} = this.props;
        const isLightColor = !(lightColor === undefined || lightColor === null) && lightColor;

        return (
	        <HeaderWrapper isMobile={isMobileOnly}>
          <StretchedBackground backgroundColor={isLightColor ? '' : sv.colors.light} showBoxShadow={true}>
            <HeaderContent isMobile={isMobileOnly}>

                {/*pass the title for the */}
                <HTMLDocumentHeadCustomizer title={pageTitle} />

                {/* Gist Logo */}
                <LogoContainer>
                    <GistLogo color={sv.colors.cta} tm={true}/>
                </LogoContainer>

                {/* If there is no user session */}
                { authState !== authenticationState.LOGGED_IN &&
                <Navigation>
                    <TextNavigationGroup>
                        {/* always show sign in and pricing page for not-loggedIn users */}
                        <OutlineButton lightColor={isLightColor} onClick={() => window.location.replace('/pricing')}>{t("Pricing")}</OutlineButton>
                        <OutlineButton lightColor={isLightColor} onClick={() => this.props.history.push('/signin')}>{t('Sign In')}</OutlineButton>
                    </TextNavigationGroup>
                    <Navigation hideSmallScreens>
                        <PitchButton onClick={this.onClickGetStarted}>{t('Get Started')}</PitchButton>
                    </Navigation>
                </Navigation>
                }
                {/* End of Not Logged In */}

                {/* If authState is LOGGED_IN */}
                { authState === authenticationState.LOGGED_IN &&
                <Navigation>

                    {/* if show create-gist or portfolio buttons */}
                    { !hideOrderOrPortfolio &&
                        <>
                        {/* If on media page, then add a order button */}
                        {screen === uiConstants.HEADER_MEDIA &&
                        <>
                            {/* Order Menu */}
                            <PitchButton
                                brightColor
                                onClick={() => this.props.history.push('/order')}
                                onMouseEnter={this.handleMouseOverOrder}
                                onMouseLeave={() => clearTimeout(this.orderMenuHover)}
                                aria-haspopup="true"
                                aria-controls="order-menu"
                            >
                                <FontAwesomeIcon icon={faPlus} style={{marginRight: 5}}/>
                                {t("Order Gist")}
                            </PitchButton>
                           

                            {/* Order Sub-Menu */}
                            <Menu
                                id="order-menu"
                                open={Boolean(this.state.orderMenuAnchor)}
                                anchorEl={this.state.orderMenuAnchor}
                                onClose={this.handleCloseOrderMenu}
                                getContentAnchorEl={null}
                                anchorOrigin={{ vertical: "bottom", horizontal: "center" }}
                                transformOrigin={{ vertical: "top", horizontal: "center" }}
                            >
                                {/* url order */}
                                <RolloverMenuItem onClick={() => this.props.history.push('/order/upload')}>
                                    {t("From") + " " + t("file")}
                                    <OrderMenuLogoContainer><FaRegFileVideo size={22}/></OrderMenuLogoContainer>
                                </RolloverMenuItem>

                                {/* url order */}
                                <RolloverMenuItem onClick={() => this.props.history.push('/order/url')}>
                                    {t("From") + " " + t("url")}
                                    <OrderMenuLogoContainer>
                                        <FontAwesomeIcon icon={faLink} style={{marginRight: 5, marginLeft: 5}}/>
                                    </OrderMenuLogoContainer>
                                </RolloverMenuItem>

                                {/* zoom order */}
                                <RolloverMenuItem onClick={() => this.props.history.push('/order/zoom')}>
                                    {t("From")}
                                    <OrderMenuLogoContainer>
                                        <ZoomIconContainer><ZoomIcon src={zoomIcon} alt="Zoom"/></ZoomIconContainer>
                                    </OrderMenuLogoContainer>
                                </RolloverMenuItem>
                            </Menu>
                        </>
                        }

                        {/* If landing page, then add additional buttons */}
                        {screen === uiConstants.HEADER_LANDING_PAGE &&
                        <TextNavigationGroup>
                            <OutlineButton lightColor={isLightColor} onClick={() => window.location.replace('/pricing')}>{t("Pricing")}</OutlineButton>
                        </TextNavigationGroup>
                        }

                        {/* If on other pages, then add a link to the media page */}
                        {screen !== uiConstants.HEADER_MEDIA &&
                        <PitchButton onClick={() => this.props.history.push('/media')}>
                            Portfolio
                        </PitchButton>
                        }

                        </>
                    } { /* End of 'hideOrderOrPortfolio' check */ }

                    {/* Account Menu */}
                    <IconButton
                        onClick={this.handleClickAccount}
                        onMouseEnter={this.handleMouseOverAccount}
                        onMouseLeave={() => clearTimeout(this.accountMenuHover)}
                        aria-haspopup="true"
                        aria-controls="account-menu"
                    >
                        <AccountCircle color="primary" fontSize="large" />
                    </IconButton>

                    {/* Account Sub-Menu */}
                    <Menu
                        id="account-menu"
                        open={Boolean(this.state.accountMenuAnchor)}
                        anchorEl={this.state.accountMenuAnchor}
                        onClose={this.handleCloseAccountMenu}
                    >
                        <MenuItem onClick={this.handleCloseAccountMenu}><UserInfo/></MenuItem>
                        <RolloverMenuItem onClick={() => this.props.history.push('/account')}>{t("Account Settings")}</RolloverMenuItem>
                        <RolloverMenuItem onClick={this.handleLogout}>{t("Sign Out")}</RolloverMenuItem>
                    </Menu>
                </Navigation>
                }
                {/* End of Logged In */}
            </HeaderContent>
	        </StretchedBackground>
          </HeaderWrapper>
        )
    }
}

function mapStateToProps(state) {
    const { authentication } = state;
    const { authState } = authentication;
    return {
        authState
    };
}

function mapDispatchToProps(dispatch) {
    return {
        clearAuthState: () => dispatch( userActions.logout() ),
    }
}

const connectedHeader = withTranslation()(withRouter(connect(mapStateToProps, mapDispatchToProps)(Header)));

export { connectedHeader as Header };